import createAxios from '@/api/axios_create'
import { getValidToken } from '@/script/storageToken'

export const _feedbackAPI = createAxios({
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'token ' + import.meta.env.VITE_APP_PAYED_API_TOKEN
    }
})

_feedbackAPI.interceptors.response.use(response => {
    return Promise.resolve(response)
}, error => {
    return Promise.reject(error)
});

const $feedbackAPI = (options) => {
    if (options.baseURL) {
        _feedbackAPI.defaults.baseURL = options.baseURL
    }


    options.method ??= 'GET'
    const staticData = {
        wstoken: getValidToken()
    }

    if (options.method === 'GET') {
        options.params = Object.assign(options.params || {}, staticData)
    } else {
        if (options.data instanceof FormData) {
            for (const name in staticData) {
                options.data.append(name, staticData[name])
            }
        } else {
            options.data = Object.assign(options.data || {}, staticData)
        }
    }

    return _feedbackAPI(options)
}
export { $feedbackAPI }